"use strict";

function __export(m) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

__export(require("./StaffRoster"));

__export(require("./GuestRoster"));

var pb_1 = require("./pb");

exports.BookingInformation = pb_1.BookingInformation;
exports.GuestChatSession = pb_1.GuestChatSession;